<div class="exp">
  <div class="exp-fondo" (click)="cerrar.emit()" (keydown.enter)="cerrar.emit()"></div>

  <div class="exp-caja" role="dialog" aria-modal="true" aria-label="Expediente del activo">

    <!-- ==================== Cabecera ==================== -->
    <div class="exp-cab">
      <div class="exp-cab-txt">
        <span class="exp-eyebrow">ISO/IEC 42001 &middot; Evidencia de trazabilidad</span>
        <strong>Expediente del activo</strong>
        <span class="exp-sub">
          <span class="exp-folio" title="Folio de este activo en la matriz de riesgos.">{{ activo.consecutivo }}</span>
          {{ activo.nombreActivo }}
          <span class="exp-tag" *ngIf="folioInv"
                title="Folio del mismo activo en el Inventario IA. Con él se buscan sus monitoreos, sus incidencias y los riesgos de proceso que lo mencionan.">{{ folioInv }}</span>
          <span class="exp-tag" *ngIf="activo.solicitudFolio"
                [title]="'Entró a la matriz al autorizarse la solicitud ' + activo.solicitudFolio + ' en Solicitudes IA: ahí está quién la pidió, para qué y con qué criterio se autorizó.'">Viene de la solicitud {{ activo.solicitudFolio }}</span>
          <span class="exp-tag apagada" *ngIf="!ligado"
                title="Al activo le falta capturar su folio del inventario, y sin él no se pueden traer sus monitoreos ni sus incidencias.">Falta el folio del inventario</span>
        </span>
      </div>
      <div class="exp-cab-acc">
        <span class="exp-sev">
          <span class="exp-chip" [ngClass]="claseRiesgo(activo.clasificacionActual)"
                title="Nivel de riesgo de hoy, antes de aplicar el plan de acción.">
            Riesgo actual&nbsp;<b>{{ activo.riesgoActual ?? '—' }}</b>
          </span>
          <span class="exp-flecha" title="La flecha marca el efecto del plan de acción: de dónde parte el riesgo y en dónde queda.">&rarr;</span>
          <span class="exp-chip" [ngClass]="claseRiesgo(activo.clasificacionResidual)"
                title="Riesgo residual: el que queda una vez ejecutado el plan de acción.">
            Riesgo residual&nbsp;<b>{{ activo.riesgoResidual ?? '—' }}</b>
          </span>
        </span>
        <button type="button" class="exp-btn-pdf" (click)="exportarPdf()" [disabled]="exportando">
          {{ exportando ? 'Generando…' : 'Exportar PDF' }}
        </button>
        <button type="button" class="exp-cerrar" (click)="cerrar.emit()">&#10005; Cerrar</button>
      </div>
    </div>

    <!-- ==================== Pestañas ==================== -->
    <div class="exp-nav">
      <button type="button" *ngFor="let s of secciones" class="exp-pestana"
              [class.activa]="pestana === s.clave" (click)="elegir(s.clave)"
              [title]="s.ayuda">
        {{ s.titulo }}
        <span class="exp-cuenta" *ngIf="conteoPestana(s.clave)">{{ conteoPestana(s.clave) }}</span>
      </button>
    </div>

    <div class="exp-cuerpo">

      <!-- ==================== 1. RESUMEN ==================== -->
      <section *ngIf="pestana === 'resumen'">

        <div class="exp-aviso rojo" *ngIf="!ligado">
          A este activo le falta su folio del Inventario IA, así que el expediente sólo puede
          mostrar lo capturado en la matriz: sin ese folio no se pueden traer sus monitoreos, sus
          incidencias ni los riesgos de proceso que lo mencionan. Para completar la evidencia,
          edite el activo y capture el campo <b>Folio del inventario IA</b>.
        </div>
        <div class="exp-aviso rojo" *ngIf="vinculoRoto">
          El folio de inventario capturado en la matriz ya no existe: apunta a un activo que fue
          borrado o renumerado. Corrija el campo <b>Folio del inventario IA</b> del activo.
        </div>

        <!-- La cadena de trazabilidad: el "match" que pide el auditor. -->
        <div class="exp-tarjeta">
          <h4 class="exp-h"
              title="El recorrido completo del activo: dónde está registrado, cómo se evaluó su riesgo, cómo se vigila y qué se ha respondido cuando algo pasa.">
            Cadena de trazabilidad
          </h4>

          <!-- La misma cadena, dicha con palabras: se lee de corrido. -->
          <p class="exp-lectura">{{ resumenLegible() }}</p>

          <div class="exp-cadena">
            <div class="exp-nodo" [class.falta]="!inventario"
                 title="El registro oficial del activo en el módulo Inventario IA: para qué se usa, quién lo opera y bajo qué supervisión.">
              <span class="exp-nodo-tit">Inventario IA</span>
              <span class="exp-nodo-dato">{{ inventario ? folioInv : (ligado ? '…' : 'sin registrar') }}</span>
              <span class="exp-nodo-pie">{{ inventario?.nombreIa || '—' }}</span>
            </div>
            <span class="exp-liga">se evalúa en</span>
            <div class="exp-nodo"
                 title="La evaluación de riesgo de este activo: sus amenazas, sus vulnerabilidades y el plan de acción para tratarlas.">
              <span class="exp-nodo-tit">Matriz de riesgos</span>
              <span class="exp-nodo-dato">{{ activo.consecutivo }}</span>
              <span class="exp-nodo-pie">
                {{ plural((activo.amenazas || []).length, 'amenaza', 'amenazas') }} &middot;
                {{ plural(acciones.length, 'acción', 'acciones') }}
              </span>
            </div>
            <span class="exp-liga">se vigila con</span>
            <div class="exp-nodo" [class.falta]="monitoreos.length === 0"
                 title="Evaluaciones periódicas del activo en el módulo Monitoreo IA: revisan su desempeño y sus riesgos durante el periodo evaluado.">
              <span class="exp-nodo-tit">Monitoreo continuo</span>
              <span class="exp-nodo-dato">{{ plural(monitoreos.length, 'evaluación', 'evaluaciones') }}</span>
              <span class="exp-nodo-pie" *ngIf="ultimoMonitoreo">
                la última salió {{ etiquetaDictamen(ultimoMonitoreo.dictamen) }}
              </span>
              <span class="exp-nodo-pie" *ngIf="!ultimoMonitoreo">todavía sin evaluar</span>
            </div>
            <span class="exp-liga">y responde a</span>
            <div class="exp-nodo" [class.falta]="totalIncidencias === 0"
                 title="Fallas, quejas o eventos que alguien reportó sobre este activo en el módulo de Incidencias IA. Son cosas que ya pasaron.">
              <span class="exp-nodo-tit">Incidencias del activo</span>
              <span class="exp-nodo-dato">{{ plural(totalIncidencias, 'incidencia', 'incidencias') }}</span>
              <span class="exp-nodo-pie">
                {{ incidenciasAbiertas ? incidenciasAbiertas + ' sin cerrar' : 'ninguna sin cerrar' }}
              </span>
            </div>
            <span class="exp-liga">y aparece en</span>
            <div class="exp-nodo" [class.falta]="procesos.length === 0"
                 title="Riesgos de la operación, no de un activo: por ejemplo, usar soluciones con IA sin evaluar su riesgo. Son los renglones del Plan de Gestión (folios RSK-DIA-001, RSK-DIA-002…); aquí salen los que mencionan a este activo.">
              <span class="exp-nodo-tit">Riesgos de proceso</span>
              <span class="exp-nodo-dato">
                {{ procesos.length === 1 ? '1 riesgo lo menciona' : procesos.length + ' riesgos lo mencionan' }}
              </span>
              <span class="exp-nodo-pie">del Plan de Gestión</span>
            </div>
          </div>
          <p class="exp-nota">
            <b>Cómo leerlo:</b> el Inventario identifica al activo, la Matriz evalúa y trata su
            riesgo, el Monitoreo demuestra la vigilancia periódica, las Incidencias muestran qué
            ha fallado y los Riesgos de proceso, qué riesgos de la operación lo involucran. Cada
            dato se lee directo de su módulo: aquí no se guarda ninguna copia.
          </p>
        </div>

        <!-- Los cruces que deben cuadrar: si alguien movió algo y una
             relación quedó rota o desalineada, aquí sale en rojo. -->
        <div class="exp-tarjeta">
          <h4 class="exp-h">
            Verificación de consistencia
            <span class="exp-check-res ok" *ngIf="inconsistencias === 0">todo cuadra</span>
            <span class="exp-check-res mal" *ngIf="inconsistencias > 0">{{ plural(inconsistencias, 'punto por revisar', 'puntos por revisar') }}</span>
          </h4>
          <ul class="exp-checks">
            <li *ngFor="let v of verificaciones()" [class.mal]="!v.ok">
              <span class="exp-check-ico" [class.mal]="!v.ok">{{ v.ok ? '✓' : '!' }}</span>
              {{ v.texto }}
            </li>
          </ul>
        </div>

        <!-- Contadores -->
        <div class="exp-kpis">
          <div class="exp-kpi">
            <span class="exp-kpi-n">{{ (activo.amenazas || []).length }}</span>
            <span class="exp-kpi-et" title="Lo que puede dañar al activo. De cada amenaza cuelgan las vulnerabilidades que la hacen posible.">Amenazas</span>
            <span class="exp-kpi-pie">{{ plural(vulnerabilidadesTotal, 'vulnerabilidad', 'vulnerabilidades') }}</span>
          </div>
          <div class="exp-kpi">
            <span class="exp-kpi-n">{{ acciones.length }}</span>
            <span class="exp-kpi-et" title="Lo que se va a hacer para bajar el riesgo. Es el plan de tratamiento del activo.">Acciones del plan</span>
            <span class="exp-kpi-pie" [class.alerta]="accionesPorAplicar > 0">
              {{ accionesPorAplicar }} por aplicar
            </span>
          </div>
          <div class="exp-kpi">
            <span class="exp-kpi-n">{{ monitoreos.length }}</span>
            <span class="exp-kpi-et" title="Evaluaciones periódicas del activo en el módulo Monitoreo IA. No confundir con los seguimientos del plan.">Monitoreos</span>
            <span class="exp-kpi-pie" *ngIf="ultimoMonitoreo">
              <span class="exp-mini" [ngClass]="claseDictamen(ultimoMonitoreo.dictamen)">
                {{ etiquetaDictamen(ultimoMonitoreo.dictamen) }}
              </span>
            </span>
            <span class="exp-kpi-pie" *ngIf="!ultimoMonitoreo">sin evaluaciones</span>
          </div>
          <div class="exp-kpi">
            <span class="exp-kpi-n">{{ totalIncidencias || incidencias.length }}</span>
            <span class="exp-kpi-et" title="Fallas, quejas o eventos que alguien reportó sobre este activo. Son cosas que ya pasaron.">Incidencias</span>
            <span class="exp-kpi-pie" [class.alerta]="incidenciasAbiertas > 0">
              {{ incidenciasAbiertas }} sin cerrar
            </span>
          </div>
          <div class="exp-kpi">
            <span class="exp-kpi-n">{{ procesos.length }}</span>
            <span class="exp-kpi-et" title="Riesgos de la operación, no de un activo: por ejemplo, usar soluciones con IA sin evaluar su riesgo. Son los renglones del Plan de Gestión, con folios RSK-DIA-001, RSK-DIA-002…">Riesgos de proceso</span>
            <span class="exp-kpi-pie" *ngIf="folioInv">del Plan de Gestión que mencionan {{ folioInv }}</span>
            <span class="exp-kpi-pie" *ngIf="!folioInv">no se pueden buscar sin el folio del inventario</span>
          </div>
          <div class="exp-kpi">
            <span class="exp-kpi-n">{{ (activo.seguimientos || []).length }}</span>
            <span class="exp-kpi-et" title="Cada revisión periódica del plan de acción: se registra la fecha y el resultado. En la matriz a esto se le llama «corte».">Seguimientos del plan</span>
            <span class="exp-kpi-pie">revisiones registradas</span>
          </div>
        </div>
      </section>

      <!-- ==================== 2. ACTIVO IA (INVENTARIO) ==================== -->
      <section *ngIf="pestana === 'inventario'">
        <p class="exp-cargando" *ngIf="cargandoInv">Consultando el inventario…</p>
        <div class="exp-aviso rojo" *ngIf="errorInv">{{ errorInv }}</div>
        <div class="exp-aviso rojo" *ngIf="vinculoRoto">
          El folio de inventario capturado en la matriz ya no existe: el vínculo está roto.
        </div>
        <div class="exp-aviso" *ngIf="!ligado">
          Este riesgo no está ligado a ningún activo del Inventario IA.
        </div>

        <ng-container *ngIf="inventario">
          <div class="exp-tarjeta">
            <h4 class="exp-h">
              {{ inventario.consecutivo }} &middot; {{ inventario.nombreIa }}
              <span class="exp-estado" [class.baja]="inventario.estatus !== 'ACTIVO'">
                {{ inventario.estatus }}
              </span>
            </h4>
            <div class="exp-filas">
              <div class="exp-fila"><span class="et">Versión</span><span class="val">{{ inventario.version || '—' }}</span></div>
              <div class="exp-fila"><span class="et">Propósito</span><span class="val pre">{{ inventario.proposito || '—' }}</span></div>
              <div class="exp-fila"><span class="et">Uso previsto</span><span class="val pre">{{ inventario.usoPrevisto || '—' }}</span></div>
              <div class="exp-fila"><span class="et">Área propietaria</span><span class="val">{{ inventario.areaNombre || '—' }}</span></div>
              <div class="exp-fila"><span class="et">Áreas usuarias</span><span class="val">{{ inventario.areasUsuariasNombres || '—' }}</span></div>
              <div class="exp-fila"><span class="et">Propietario externo</span><span class="val">{{ inventario.propietarioExterno || '—' }}</span></div>
              <div class="exp-fila"><span class="et">Ciclo de vida</span><span class="val">{{ inventario.cicloVidaNombre || '—' }}</span></div>
              <div class="exp-fila"><span class="et">Nivel de supervisión</span><span class="val">{{ inventario.nivelSupervisionNombre || '—' }}</span></div>
              <div class="exp-fila"><span class="et">Ubicación</span><span class="val">{{ inventario.ubicacion || '—' }}</span></div>
              <div class="exp-fila"><span class="et">Fecha de alta</span><span class="val">{{ inventario.fechaAlta | date: 'dd/MM/yyyy' }}</span></div>
            </div>
          </div>

          <div class="exp-tarjeta" *ngIf="inventario.impactos && inventario.impactos.length">
            <h4 class="exp-h">Impactos identificados</h4>
            <div class="exp-scroll">
              <table class="exp-tabla">
                <thead>
                  <tr><th>Tipo</th><th>Impacto positivo</th><th>Impacto negativo</th></tr>
                </thead>
                <tbody>
                  <tr *ngFor="let im of inventario.impactos">
                    <td class="nw">{{ im.tipoImpactoNombre || '—' }}</td>
                    <td class="pre">{{ im.descripcionPositivo || '—' }}</td>
                    <td class="pre">{{ im.descripcionNegativo || '—' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-container>
      </section>

      <!-- ==================== 3. RIESGO EN LA MATRIZ ==================== -->
      <section *ngIf="pestana === 'riesgo'">

        <div class="exp-tarjeta">
          <h4 class="exp-h">Valoración del activo</h4>
          <div class="exp-valores">
            <span class="exp-dim" title="Qué tan grave sería que la información del activo se revelara a quien no debe.">
              Confidencialidad <b>{{ activo.valConfidencialidad ?? '—' }}</b>
            </span>
            <span class="exp-dim" title="Qué tan grave sería que su información se alterara sin autorización.">
              Integridad <b>{{ activo.valIntegridad ?? '—' }}</b>
            </span>
            <span class="exp-dim" title="Qué tan grave sería que el activo dejara de estar disponible.">
              Disponibilidad <b>{{ activo.valDisponibilidad ?? '—' }}</b>
            </span>
            <span class="exp-dim total" title="El más alto de los tres: confidencialidad, integridad y disponibilidad.">
              Valor del activo <b>{{ activo.valorActivo ?? '—' }}</b>
            </span>
            <span class="exp-espacio"></span>
            <span class="exp-chip grande" [ngClass]="claseRiesgo(activo.clasificacionActual)"
                  title="Nivel de riesgo de hoy, antes de aplicar el plan de acción.">
              Riesgo actual <b>{{ activo.riesgoActual ?? '—' }}</b> {{ activo.clasificacionActual || '' }}
            </span>
            <span class="exp-flecha" title="La flecha marca el efecto del plan de acción: de dónde parte el riesgo y en dónde queda.">&rarr;</span>
            <span class="exp-chip grande" [ngClass]="claseRiesgo(activo.clasificacionResidual)"
                  title="Riesgo residual: el que queda una vez ejecutado el plan de acción.">
              Riesgo residual <b>{{ activo.riesgoResidual ?? '—' }}</b> {{ activo.clasificacionResidual || '' }}
            </span>
          </div>
          <div class="exp-filas">
            <div class="exp-fila" *ngIf="activo.periodicidadMaxima">
              <span class="et" title="Cada cuánto, como máximo, toca volver a revisar este activo y registrar el seguimiento.">Periodicidad de revisión</span><span class="val">{{ activo.periodicidadMaxima }}</span>
            </div>
            <div class="exp-fila" *ngIf="activo.fechaIdentificacion">
              <span class="et">Identificado el</span><span class="val">{{ activo.fechaIdentificacion | date: 'dd/MM/yyyy' }}</span>
            </div>
            <div class="exp-fila" *ngIf="activo.justificacionValoracion">
              <span class="et">Justificación</span><span class="val pre">{{ activo.justificacionValoracion }}</span>
            </div>
            <div class="exp-fila" *ngIf="activo.activosDependientes">
              <span class="et">Activos dependientes</span><span class="val pre">{{ activo.activosDependientes }}</span>
            </div>
          </div>
        </div>

        <div class="exp-tarjeta" *ngFor="let am of activo.amenazas || []">
          <h4 class="exp-h">
            <span class="exp-cat" *ngIf="am.catAmenazaCategoria">{{ am.catAmenazaCategoria }}</span>
            {{ am.nombreAmenaza }}
            <span class="exp-prob">probabilidad <b>{{ am.probActual ?? '—' }}</b> &rarr; <b>{{ am.probTrasPlan ?? '—' }}</b></span>
          </h4>
          <div class="exp-vul" *ngFor="let v of am.vulnerabilidades || []">
            <div class="exp-vul-cab">
              <span class="exp-vul-et">Vulnerabilidad</span>
              {{ v.nombreVulnerabilidad }}
              <span class="exp-prob">prob. <b>{{ v.probActual ?? '—' }}</b> &rarr; <b>{{ v.probTrasPlan ?? '—' }}</b></span>
            </div>
            <div class="exp-scroll" *ngIf="v.acciones && v.acciones.length">
              <table class="exp-tabla">
                <thead>
                  <tr><th>Acción</th><th>Responsable</th><th>Prioridad</th><th>Estado</th><th>Fecha</th></tr>
                </thead>
                <tbody>
                  <tr *ngFor="let ac of v.acciones">
                    <td class="pre">{{ ac.descripcion || '—' }}</td>
                    <td class="nw">{{ ac.responsable || '—' }}</td>
                    <td class="nw">{{ ac.prioridad || '—' }}</td>
                    <td class="nw"><span class="exp-mini" [ngClass]="claseAccion(ac.estado)">{{ ac.estado || '—' }}</span></td>
                    <td class="nw">{{ ac.fechaEjecucion | date: 'dd/MM/yyyy' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p class="exp-vacio" *ngIf="!v.acciones || v.acciones.length === 0">Sin acciones capturadas.</p>
          </div>
        </div>
        <p class="exp-vacio" *ngIf="!activo.amenazas || activo.amenazas.length === 0">
          Sin amenazas capturadas para este activo.
        </p>

        <div class="exp-tarjeta" *ngIf="activo.seguimientos && activo.seguimientos.length">
          <h4 class="exp-h">Cortes de seguimiento</h4>
          <div class="exp-scroll">
            <table class="exp-tabla">
              <thead><tr><th>Fecha</th><th>Resultado</th><th>Registró</th></tr></thead>
              <tbody>
                <tr *ngFor="let s of activo.seguimientos">
                  <td class="nw">{{ s.fechaMonitoreo | date: 'dd/MM/yyyy' }}</td>
                  <td class="pre">{{ s.resultado || '—' }}</td>
                  <td class="nw">{{ s.usuarioNombre || '—' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <!-- ==================== 4. MONITOREOS ==================== -->
      <section *ngIf="pestana === 'monitoreo'">
        <p class="exp-cargando" *ngIf="cargandoMon">Consultando los monitoreos…</p>
        <div class="exp-aviso rojo" *ngIf="errorMon">{{ errorMon }}</div>
        <div class="exp-aviso" *ngIf="!ligado">
          No aplica: el riesgo no está ligado a un activo del inventario.
        </div>

        <div class="exp-tarjeta" *ngIf="!cargandoMon && ligado && !errorMon">
          <h4 class="exp-h">Evaluaciones de monitoreo continuo</h4>
          <div class="exp-scroll" *ngIf="monitoreos.length">
            <table class="exp-tabla">
              <thead>
                <tr><th>Folio</th><th>Fecha</th><th>Dictamen</th><th>Conclusión</th><th>Registró</th></tr>
              </thead>
              <tbody>
                <tr *ngFor="let m of monitoreos">
                  <td class="nw"><b>{{ m.consecutivo || '—' }}</b></td>
                  <td class="nw">{{ m.fechaEvaluacion | date: 'dd/MM/yyyy' }}</td>
                  <td class="nw"><span class="exp-mini" [ngClass]="claseDictamen(m.dictamen)">{{ etiquetaDictamen(m.dictamen) }}</span></td>
                  <td class="nw">{{ etiquetaConclusion(m.conclusion) }}</td>
                  <td class="nw">{{ m.usuarioAltaNombre || '—' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="exp-vacio" *ngIf="!monitoreos.length">Este activo aún no tiene evaluaciones de monitoreo.</p>
          <p class="exp-nota">
            El detalle de los seis aspectos de cada evaluación se consulta en
            Inventario IA &rarr; Monitoreo.
          </p>
        </div>
      </section>

      <!-- ==================== 5. INCIDENCIAS ==================== -->
      <section *ngIf="pestana === 'incidencias'">
        <p class="exp-cargando" *ngIf="cargandoInc">Consultando las incidencias…</p>
        <div class="exp-aviso rojo" *ngIf="errorInc">{{ errorInc }}</div>
        <div class="exp-aviso" *ngIf="!ligado">
          No aplica: el riesgo no está ligado a un activo del inventario.
        </div>

        <div class="exp-tarjeta" *ngIf="!cargandoInc && ligado && !errorInc">
          <h4 class="exp-h">Incidencias reportadas sobre el activo</h4>
          <div class="exp-scroll" *ngIf="incidencias.length">
            <table class="exp-tabla">
              <thead>
                <tr><th>#</th><th>Apertura</th><th>Evento</th><th>Gravedad</th><th>Estado</th><th>Responsable</th><th>Resolución planeada</th></tr>
              </thead>
              <tbody>
                <tr *ngFor="let i of incidencias">
                  <td class="nw"><b>#{{ i.idIncidenciaIa }}</b></td>
                  <td class="nw">{{ i.fechaApertura | date: 'dd/MM/yyyy' }}</td>
                  <td class="pre">{{ i.descripcionEvento || '—' }}<span class="exp-sublinea" *ngIf="i.tipoEvento"> ({{ i.tipoEvento }})</span></td>
                  <td class="nw">{{ i.gravedad || '—' }}</td>
                  <td class="nw"><span class="exp-mini" [ngClass]="claseEstadoInc(i.estadoEvento)">{{ etiquetaEstadoInc(i.estadoEvento) }}</span></td>
                  <td class="nw">{{ i.responsableResolucion || i.nombreResponsableSeguimiento || '—' }}</td>
                  <td class="nw">{{ i.fechaPlaneadaResolucion | date: 'dd/MM/yyyy' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="exp-vacio ok" *ngIf="!incidencias.length">Sin incidencias registradas para este activo.</p>
          <p class="exp-nota" *ngIf="incidencias.length < totalIncidencias">
            Se muestran las {{ incidencias.length }} más recientes de {{ totalIncidencias }} registradas.
          </p>
          <p class="exp-nota">
            Los comentarios y archivos adjuntos de cada incidencia viven en el módulo de
            Incidencias IA.
          </p>
        </div>
      </section>

      <!-- ==================== 6. RIESGOS DE PROCESO ==================== -->
      <section *ngIf="pestana === 'procesos'">
        <p class="exp-cargando" *ngIf="cargandoProc">Consultando los riesgos de proceso…</p>
        <div class="exp-aviso rojo" *ngIf="errorProc">{{ errorProc }}</div>

        <div class="exp-tarjeta" *ngIf="!cargandoProc && !errorProc">
          <h4 class="exp-h">Riesgos de proceso que citan el folio {{ folioInv || '—' }}</h4>
          <div class="exp-scroll" *ngIf="procesos.length">
            <table class="exp-tabla">
              <thead>
                <tr><th>Folio</th><th>Descripción</th><th>Severidad</th><th>Estrategia</th><th>Estatus</th></tr>
              </thead>
              <tbody>
                <tr *ngFor="let r of procesos">
                  <td class="nw"><b>{{ r.consecutivo || '—' }}</b></td>
                  <td class="pre">{{ r.descripcion || '—' }}</td>
                  <td class="nw">
                    <span class="exp-mini" [ngClass]="claseBanda(r.clasificacionInicial)">{{ r.severidadInicial ?? '—' }}</span>
                    &rarr;
                    <span class="exp-mini" [ngClass]="claseBanda(r.clasificacionReevaluada)">{{ r.severidadReevaluada ?? '—' }}</span>
                  </td>
                  <td class="nw">{{ r.estrategia || '—' }}</td>
                  <td class="nw">{{ r.estatus || '—' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="exp-vacio" *ngIf="!procesos.length && folioInv">
            Ningún riesgo de proceso cita este activo en su campo "Activos relacionados".
          </p>
          <p class="exp-vacio" *ngIf="!folioInv">
            Sin folio de inventario no hay forma de buscar el activo en los riesgos de proceso.
          </p>
          <p class="exp-nota">
            El cruce se hace por el folio citado en el campo de texto "Activos relacionados"
            del Plan de Gestión.
          </p>
        </div>
      </section>

      <!-- ==================== 7. EVIDENCIAS ADJUNTAS ==================== -->
      <section *ngIf="pestana === 'evidencias'">
        <p class="exp-cargando" *ngIf="cargandoEvd">Consultando las evidencias…</p>

        <div class="exp-tarjeta">
          <h4 class="exp-h">Evidencias del activo en la matriz</h4>
          <div class="exp-evd" *ngFor="let evd of evidenciasActivo">
            <span class="exp-evd-ico">{{ iconoEvidencia(evd) }}</span>
            <div class="exp-evd-txt">
              <span class="exp-evd-nombre">{{ evd.nombreArchivo }}</span>
              <span class="exp-evd-meta">
                {{ tamanoLegible(evd.tamanioBytes) }} · {{ evd.fechaCarga | fechaBitacora }}
                <ng-container *ngIf="evd.usuarioNombre">· {{ evd.usuarioNombre }}</ng-container>
                <ng-container *ngIf="evd.descripcion">· {{ evd.descripcion }}</ng-container>
              </span>
            </div>
            <span class="exp-espacio"></span>
            <button type="button" class="exp-btn-evd" (click)="verEvidencia(evd)">Ver</button>
            <button type="button" class="exp-btn-evd" (click)="guardarEvidencia(evd)">Descargar</button>
          </div>
          <p class="exp-vacio ok" *ngIf="evidenciasAplicaActivo === 'NO'">
            Marcadas como <b>No aplica</b> para este activo: estado declarado, no un faltante.
          </p>
          <p class="exp-vacio" *ngIf="!cargandoEvd && evidenciasActivo.length === 0 && evidenciasAplicaActivo !== 'NO'">
            Sin evidencias adjuntas al activo.
          </p>
        </div>

        <div class="exp-tarjeta" *ngFor="let p of evidenciasProcesos">
          <h4 class="exp-h">Evidencias del riesgo {{ p.proceso.consecutivo }}</h4>
          <div class="exp-evd" *ngFor="let evd of p.lista">
            <span class="exp-evd-ico">{{ iconoEvidencia(evd) }}</span>
            <div class="exp-evd-txt">
              <span class="exp-evd-nombre">{{ evd.nombreArchivo }}</span>
              <span class="exp-evd-meta">
                {{ tamanoLegible(evd.tamanioBytes) }} · {{ evd.fechaCarga | fechaBitacora }}
                <ng-container *ngIf="evd.usuarioNombre">· {{ evd.usuarioNombre }}</ng-container>
              </span>
            </div>
            <span class="exp-espacio"></span>
            <button type="button" class="exp-btn-evd" (click)="verEvidencia(evd)">Ver</button>
            <button type="button" class="exp-btn-evd" (click)="guardarEvidencia(evd)">Descargar</button>
          </div>
          <p class="exp-vacio ok" *ngIf="p.aplica === 'NO'">
            Marcadas como <b>No aplica</b> para este riesgo: estado declarado, no un faltante.
          </p>
          <p class="exp-vacio" *ngIf="p.lista.length === 0 && p.aplica !== 'NO'">Sin evidencias adjuntas a este riesgo.</p>
        </div>

        <p class="exp-nota">
          Las evidencias se suben y se administran desde la Matriz (sección Evidencias de cada
          activo) y desde el Plan de Gestión (sección Evidencias de cada riesgo). Aquí sólo se
          consultan.
        </p>
      </section>

      <!-- ==================== 8. BITÁCORAS ==================== -->
      <section *ngIf="pestana === 'bitacora'">

        <div class="exp-tarjeta">
          <h4 class="exp-h">Bitácora del riesgo en la matriz</h4>
          <p class="exp-cargando" *ngIf="cargandoHistMat">Consultando…</p>
          <div class="exp-aviso rojo" *ngIf="errorHistMat">{{ errorHistMat }}</div>
          <ng-container *ngTemplateOutlet="tablaBitacora; context: { $implicit: histMatriz }"></ng-container>
          <p class="exp-vacio" *ngIf="!cargandoHistMat && !errorHistMat && !histMatriz.length">Sin movimientos registrados.</p>
        </div>

        <div class="exp-tarjeta">
          <h4 class="exp-h">Bitácora del activo en el inventario</h4>
          <p class="exp-cargando" *ngIf="cargandoHistInv">Consultando…</p>
          <div class="exp-aviso rojo" *ngIf="errorHistInv">{{ errorHistInv }}</div>
          <div class="exp-aviso" *ngIf="!ligado">No aplica: el riesgo no está ligado al inventario.</div>
          <ng-container *ngTemplateOutlet="tablaBitacora; context: { $implicit: histInv }"></ng-container>
          <p class="exp-vacio" *ngIf="ligado && !cargandoHistInv && !errorHistInv && !histInv.length">Sin movimientos registrados.</p>
        </div>

        <!-- La tabla de una bitácora: la de la matriz y la del inventario se pintan igual. -->
        <ng-template #tablaBitacora let-filas>
          <div class="exp-scroll" *ngIf="filas.length">
            <table class="exp-tabla">
              <thead>
                <tr><th>Fecha</th><th>Usuario</th><th>Acción</th><th>Campo</th><th>Cambio</th></tr>
              </thead>
              <tbody>
                <tr *ngFor="let h of filas">
                  <td class="nw">{{ h.fechaCambio | fechaBitacora }}</td>
                  <td class="nw">{{ h.usuarioNombre || '—' }}</td>
                  <td class="nw">{{ etiquetaAccionBit(h.accion) }}</td>
                  <td class="nw">{{ etiquetaCampo(h.campoModificado) }}</td>
                  <td class="exp-hist-cambio">
                    <span class="ant" *ngIf="h.valorAnterior">{{ valorLegible(h.valorAnterior) }}</span>
                    <span class="exp-flecha" *ngIf="h.valorAnterior && h.valorNuevo">&rarr;</span>
                    <span class="nvo" *ngIf="h.valorNuevo">{{ valorLegible(h.valorNuevo) }}</span>
                    <span *ngIf="!h.valorAnterior && !h.valorNuevo">—</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-template>
      </section>

    </div>
  </div>
</div>
